export enum CustomErrorCodes {
  USERS_EXIST_IN_OTHER_INSTITUTIONS = 'USERS_EXIST_IN_OTHER_INSTITUTIONS',
  USERS_EXIST_IN_SAME_INSTITUTION = 'USERS_EXIST_IN_SAME_INSTITUTION',
  SIGNUP_BLOCKED_DISPOSABLE_EMAIL = 'SIGNUP_BLOCKED_DISPOSABLE_EMAIL'
}
